import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

import { LinkButton } from "./ui";

export function CTA() {
  return (
    <section className="relative overflow-hidden border-t border-border py-32">
      <div className="absolute inset-0 bg-primary/[0.04]" />
      <div className="absolute inset-0 bg-gt-grid opacity-20" />

      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="mb-8 inline-flex items-center gap-3">
            <div className="h-px w-12 bg-primary" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-primary">Green Flag</span>
            <div className="h-px w-12 bg-primary" />
          </div>

          <h2 className="mb-6 font-display text-5xl font-bold uppercase leading-[0.95] tracking-tight text-text md:text-7xl lg:text-8xl">
            Ready To Go Green?
          </h2>
          <p className="mx-auto mb-10 max-w-2xl text-lg text-muted md:text-xl">
            Join broadcasters around the world delivering professional-grade iRacing streams with iBox.
          </p>
          <div className="flex flex-col justify-center gap-3 sm:flex-row">
            <LinkButton href="/download" size="lg">
              DOWNLOAD IBOX <ArrowRight size={16} />
            </LinkButton>
            <LinkButton href="/docs/" variant="ghost" size="lg">
              VIEW DOCS
            </LinkButton>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
